import { createTheme, ThemeProvider } from "@mui/material/styles";
import Head from "next/head";

import NavBar from "components/nav/NavBar";
import { SourceChainContext } from "hooks/sourceChain";
import { SourceChain } from "lib/chains";
import { NextRouter, useRouter } from "next/router";
import { ReactNode, useState } from "react";
import Balancer from "react-wrap-balancer";

const theme = createTheme({});

const SuccinctLayout = ({
  children,
  header,
}: {
  header?: string | ((router: NextRouter) => string);
  children: ReactNode;
}) => {
  const router = useRouter();
  const realHeader = header instanceof Function ? header(router) : header;
  const [sourceChain, setSourceChain] = useState("mainnet" as SourceChain);

  return (
    <>
      <Head>
        <title>Telepathy Explorer</title>
        <meta
          name="description"
          content="Multichain explorer for the Succinct data transfer layer"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ThemeProvider theme={theme}>
        <main className="bg-gradient relative flex h-full min-h-screen flex-col items-center pb-[60px] text-white">
          <div className="favorit-light relative left-[50%] ml-[-100vw] w-[100vw] bg-succinct-teal-10 py-2 text-center text-white">
            <Balancer>
              <a
                className="underline"
                href="https://telepathy.xyz"
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                Telepathy
              </a>{" "}
              is Ethereum&rsquo;s first interoperability protocol secured by
              proof of consensus. Read our{" "}
              <a
                className="underline"
                href="https://docs.telepathy.xyz"
                target="_blank"
                referrerPolicy="no-referrer"
                rel="noreferrer"
              >
                docs
              </a>{" "}
              for more information.
            </Balancer>
          </div>
          <>
            <div className="min-h-full w-full">
              <div className="pb-0">
                <NavBar
                  sourceChain={sourceChain}
                  setSourceChain={setSourceChain}
                />
                <header className="pt-6 pb-2">
                  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    {realHeader !== undefined ? (
                      <h1 className="text-xl text-white">{realHeader}</h1>
                    ) : (
                      ""
                    )}
                  </div>
                </header>
              </div>

              <main className="mt-2">
                <div className="mx-auto max-w-7xl space-y-4 px-4 pb-2 sm:px-6 lg:px-8">
                  <SourceChainContext.Provider value={sourceChain}>
                    {children}
                  </SourceChainContext.Provider>
                </div>
              </main>

              <footer className="absolute bottom-0 flex h-[60px] w-full items-center justify-center rounded-lg px-4 text-white shadow sm:px-6 lg:px-8">
                <span className="block text-sm text-gray-500 dark:text-gray-400 sm:text-center">
                  ©{" "}
                  <a href="https://succinct.xyz/" className="hover:underline">
                    Succinct Labs
                  </a>
                  . All Rights Reserved.
                </span>
              </footer>
            </div>
          </>
        </main>
      </ThemeProvider>
    </>
  );
};

export default SuccinctLayout;
